export enum LoginResultEnum {
	Success,
	BadCredentials,
	OtherError,
}
